import { GLOBAL_LOADER_TOGGLE } from 'js/components/shared/constants';

import { HARD_PAGE_LOADER } from '../constants';

const toggleGlobalLoader = function (isShow, name = 'unnamed') {
  return {
    type: GLOBAL_LOADER_TOGGLE,
    payload: {
      isShow,
      name,
    },
  }
}

/** Full-page overlay — currently only bfcache reload on booking steps. */
export const toggleHardPageLoader = function (isShow) {
  return toggleGlobalLoader(isShow, HARD_PAGE_LOADER)
}

export default toggleGlobalLoader
